import React, { Component } from 'react';
import ProductMain from '../../components/Product/product.main';
import LayoutPreload from '../../components/Preload/layout.preload';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../store/actions';
import _ from 'lodash';
import { withRouter } from 'react-router';

class ProductPage extends Component {
    componentDidMount() {
        const { firebaseAuth } = this.props;
        if (!window.localStorage.getItem("Hello") || firebaseAuth) {
            this.handlerSet();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { productdata, currentLanguage, firebaseAuth } = this.props;
        if (!_.isEqual(prevProps.productdata, productdata) && productdata != null) {
            this.mod();
        }
        if (
            !_.isEqual(prevProps.currentLanguage, currentLanguage) ||
            !_.isEqual(prevProps.firebaseAuth, firebaseAuth)
        ) {
            this.handlerSet();
        }
    }

    handlerSet = () => {
        const { updateWording, match, getItemById, type } = this.props;
        const itemName = match.params.name.split('-').join(' ');
        updateWording();
        getItemById(itemName, type);
    }

    mod = () => {
        const { productdata } = this.props;
        // document.getElementById('meta[property=og:title]').remove();
        // document
        //     .getElementById('title')
        //     .setAttribute('content', `${productdata.name}`);
        // document
        //     .getElementById('description')
        //     .setAttribute('content', `${productdata.desc}`);
        // document
        //     .getElementById('image')
        //     .setAttribute(
        //         'content',
        //         `https://sfshop-apidev.sfcinemacity.com/image/product/${productdata.items[0].pictures[0]}`
        //     );
        // document.createElement('head').append( `<meta property="og:title" content="${productdata.name}" />` );
        document.title = productdata.name;
    };

    componentWillUnmount() {
        const { ClearProduct } = this.props;
        ClearProduct();
        document.title = "SF Shop";
    }

    render() {
        const { match, productFetching, type } = this.props;
        if (productFetching) {
            return <LayoutPreload />;
        }

        return (
            <ProductMain itemName={match.params.name.split('-').join(' ')} type={type} />
        );
    }
}

const mapStateToProps = ({ product, language, login }) => ({
    productFetching: product.productFetching,
    productdata: product.data,
    currentLanguage: language.currentLanguage,
    firebaseAuth: login.firebaseAuth
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            updateWording: Actions.updateWording,
            getItemById: Actions.getItemById,
            ClearProduct: Actions.ClearProduct
        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProductPage));
